import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import styles from './BrandCard.module.css';

export default function BrandCard({ brand }) {
  return (
    <div className={styles.card}>
      {/* Header with color accent */}
      <div className={styles.header} style={{ background: brand.color }}>
        {brand.logo ? (
          <img
            src={brand.logo}
            alt={brand.name}
            className={styles.logo}
            onError={(e) => {
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        ) : null}
        <div className={styles.logoFallback} style={{ display: brand.logo ? 'none' : 'flex' }}>
          {brand.isFeatured && <span className={styles.featuredStar}>⭐ </span>}
          {brand.logoFallbackText || brand.name}
        </div>
      </div>

      {/* Body */}
      <div className={styles.body}>
        <h3 className={styles.name}>{brand.name}</h3>
        <p className={styles.tagline}>{brand.tagline}</p>
        <p className={styles.brief}>{brand.brief}</p>
        <div className={styles.meta}>
          <span className={styles.count}>{brand.productCategories.length} Product Lines</span>
        </div>
        <Link to={`/brands/${brand.slug}`} className={styles.btn}>
          View Products <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  );
}
